import { CORE_AXIOS, type Http } from '@/core'
import { container } from 'tsyringe'
import type { bannerListType, materialsListType, spusListType } from './interface/homeinterface'
import type { beforeAfterContent, categoriesDetailArray, categoriesMenusState, searchType, sectorListType, sectorType } from './interface/sectorinterface'

// 查询展示的spus
export const getSpus = async (): Promise<spusListType> => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return await axios.get('/v1/api/pms/spus_top', { limit: 4 })
}

// 查询展示的素材
export const getMaterials = async () => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return await axios.get('/v1/api/pms/materials_top', { limit: 5, materials_list: 3 })
}
// 获取轮播图
export const getBanners = async (): Promise<bannerListType> => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return await axios.get('/v1/api/banners')
}
// cms栏目
export const getSector = async (id?: number, limit?: number, offset?: number): Promise<sectorListType> => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  let pathString = '/v1/api/cms/sector'
  if (id && limit || offset) pathString = pathString + `/${id}?limit=${limit}&offset=${offset}`
  else if (id) pathString = pathString + `/${id}`
  return await axios.get(pathString)
}
// cms栏目
export const getSectorList = async (): Promise<sectorListType> => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return await axios.get('/v1/api/cms/sector')
}

// 根据栏目查找文章列表
export const getArticleFromSector = async (id: number, data: { limit: number, offset: number }): Promise<{ rows: sectorType['contents'], total: number }> => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return await axios.get('/v1/api/cms/sector/contentFromSector/' + id, data)
}

// 根据文章查找上一篇下一篇
export const getArticleBeforeAfter = async (id: number): Promise<beforeAfterContent> => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return await axios.get('/v1/api/cms/sector/contentBeforeAfter/' + id)
}

// cms搜索
export const getSectorSearch = async (data: searchType): Promise<{ rows: sectorType['contents'], total: number }> => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return await axios.get('/v1/api/cms/sector/content', data)
}
// 查询单个文章
export const getSingleContent = async (id: number | string) => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return await axios.get('/v1/api/cms/content/' + id)
}

/** 获取产品种类接口 */
export async function categories(): Promise<categoriesMenusState> {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return axios.get<categoriesMenusState>('/v1/api/pms/categories')
}

/** 根据产品种类,获取种类下的全部商品 */
export async function categoriesDetail(id: number): Promise<categoriesDetailArray> {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return axios.get<categoriesDetailArray>("/v1/api/pms/categories/" + id + "/spus")
}

export async function creatAiImage(data: any): Promise<void> {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return axios.post("/v1/api/mj/create", data)
}

export async function queryGroup(taskId: any): Promise<void> {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return axios.get(`/v1/api/mj/queryGroup/${taskId}`)
}

export async function querySub(groupId: any): Promise<void> {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return axios.get(`/v1/api/mj/querySub/${groupId}`)
}

export async function queryHistory(): Promise<void> {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return axios.get(`/v1/api/mj/queryHistory`)
}